module.exports = __webpack_public_path__ + "static/media/FacebookRounded.17cdc6ee.svg";